import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import Pagination from '../layouts/pagination.jsx';
import AddAssignProject from './sections/add.jsx';
import EditAssignProject from './sections/edit.jsx';
import ExcelExport from './sections/export.jsx';


const AssignProject = () => {
    const [projects, setProjects] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [projectId, setProjectId] = useState(null);
    const [filterChannel, setFilterChannel] = useState('');
    const [filterClient, setFilterClient] = useState('');
    const [filterProject, setFilterProject] = useState('');
    const [exportProjects, setExportProjects] = useState([]);

    const fetchExportEmployees = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/assign_project`)
            .then(response => {
                setExportProjects(response.data.data);
            })
            .catch(error => {
                console.error("Error fetching assign projects!", error);
                setExportProjects([]);
            });
    };

    const fetchAssignProjects = async (currentPage) => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/assign_project?page=${currentPage + 1}`)
            .then(response => {
                setProjects(response.data.data);
                setPageCount(Math.ceil(response.data.meta.pagination.total / response.data.meta.pagination.per_page));
            })
            .catch(error => {
                console.error("Error fetching assign projects!", error);
                setProjects([]);
            });
    };

    
    useEffect(() => {
        fetchAssignProjects(currentPage);
        fetchExportEmployees();
    }, [currentPage]);
    
    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };

    // Search input handler
    const filteredItems = projects.filter((item) => {
        const matchesChannel = item.channel.toLowerCase().includes(filterChannel.toLowerCase());
        const matchesClient = item.client.toLowerCase().includes(filterClient.toLowerCase());
        const matchesProject = item.project.toLowerCase().includes(filterProject.toLowerCase());
        return matchesChannel && matchesClient && matchesProject;
    });

    const MAX_LENGTH = 40;
    const truncateText = (text) => {  
        return text.length > MAX_LENGTH ? text.substring(0, MAX_LENGTH) + '...' : text;  
    };
    
    return(
        <>
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center timeLog">
                        <div className="col">
                            <h3 className="page-title">Assign Project</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Assign Project</li>
                            </ul>
                        </div>
                        <div className="col-auto float-end ms-auto">
                            <Link to="#" className="btn add-btn" data-bs-toggle="modal" data-bs-target="#assign_project"><i className="fa-solid fa-plus"></i> Assign Project</Link>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-3 mb-3">
                        <input className="form-control" type="text"
                            placeholder="Search Channel..." aria-label="Search Input"
                            value={filterChannel} onChange={(event)=>{
                                setFilterChannel(event.target.value)
                            }} />
                    </div>
                    <div className="col-md-3 mb-3">
                        <input className="form-control" type="text"
                            placeholder="Search Client..." aria-label="Search Input"
                            value={filterClient} onChange={(event)=>{
                                setFilterClient(event.target.value)
                            }} />
                    </div>
                    <div className="col-md-3 mb-3">
                        <input className="form-control" type="text"
                            placeholder="Search Project..." aria-label="Search Input"
                            value={filterProject} onChange={(event)=>{
                                setFilterProject(event.target.value)
                            }} />
                    </div>
                    <div className="col-md-3 mb-3 empInput" align="right">
                        <ExcelExport data={exportProjects} fileName="ActiveProject" />
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <table className="table table-striped custom-table">
                                        <thead>
                                            <tr>
                                                <th>Channel Name</th>
                                                <th>Client Name</th>
                                                <th>Project Name</th>
                                                <th>Department</th>
                                                <th>Employees</th>
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                filteredItems.length > 0 ? (
                                                    filteredItems.map((project) => (
                                                        <tr key={project.id}>
                                                            <td>{project.channel}</td>
                                                            <td>{project.client}</td>
                                                            <td>{project.project}</td>
                                                            <td>{project.department}</td>
                                                            <td>{project.employees ? truncateText(project.employees) : ''}</td>
                                                            <td className="text-end">
                                                                <div className="dropdown dropdown-action">
                                                                    <Link to="#" className="action-icon dropdown-toggle"
                                                                        data-bs-toggle="dropdown" aria-expanded="false"
                                                                            onClick={() => setProjectId(`${project.id}`)}>
                                                                            <i className="material-icons">more_vert</i></Link>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <Link className="dropdown-item" to="#" data-bs-toggle="modal"
                                                                            data-bs-target={`#edit_assign_project_${project.id}`}>
                                                                                <i className="fa-solid fa-pencil m-r-5"></i> Edit</Link>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="6">No records found</td>
                                                    </tr>
                                                ) 
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Pagination pageCount={pageCount} handlePageClick={handlePageClick}/>
            </div>

            <AddAssignProject list={fetchAssignProjects}/>
            <EditAssignProject list={fetchAssignProjects} projectId={projectId} />
        </>
    );
}

export default AssignProject